import { Messages } from '~src/codegen/Localize';

import { IPasswordPolicy } from './IPasswordPolicy';

export class MinimumPasswordLengthPolicy implements IPasswordPolicy {

    private minLength: number;

    public constructor(minLength: number) {
        this.minLength = minLength;
    }

    public isValid(password: string): boolean {
        return password && password.length >= this.minLength;
    }

    public getErrorMessage(): string {
        return Messages.passwordPolicies_minimumLength({MIN_LENGTH: this.minLength.toString()});
    }

    public getTestId(): string {
        return MinimumPasswordLengthPolicy.name;
    }
}
